type Extensions = Record<string, string | number[]>;

type InnerErrors = {
  message: string;
  status: number;
  path: string;
  extensions: Extensions;
}[];

export type GQLError = {
  response?: {
    errors: InnerErrors;
  };
};

export type ParsedError = {
  field: string;
  errorMessage: string;
  ids?: (string | number)[];
};

//Check the msg for status codes, used to display generic snackbar messages for authorization and duplicate entries
// the returned strings are children of genericErrors in the translations json

export function createGenericErrorMessage(error: GQLError) {
  const message = error?.response?.errors?.[0]?.message || '';
  const status = error?.response?.errors?.[0]?.status;
  if (message.includes('401') || status === 401) {
    return 'notAuthorized';
  } else if (message.includes('409') || status === 409 || message.includes('unique constraint was violated')) {
    return 'duplicateEntry';
  }
  return '';
}

//Mapping of error patterns to their respective fields and custom error messages
const errorPatterns = [
  {
    pattern: /user already exists/,
    path: 'inviteUser',
    field: 'email',
    message: 'The user already exists',
  },
  {
    pattern: /unique constraint was violated/,
    path: 'createOrganisation',
    field: 'name',
    message: 'This name already exists',
  },
  {
    pattern: /unique constraint was violated/,
    path: 'createWatcherType',
    field: 'externalIdentifier',
    message: 'This identifier already exists',
  },
  {
    pattern: /unique constraint was violated/,
    path: 'createGreenerEye',
    field: 'externalIdentifier',
    message: 'This identifier already exists',
  },
  {
    pattern: /unique constraint was violated/,
    path: 'createGreenerUnit',
    field: 'externalIdentifier',
    message: 'This identifier already exists',
  },
  {
    pattern: /Could not update instances/,
    path: 'updateGreenerEye',
    field: 'externalIdentifier',
    message: 'This identifier cannot be updated, likely a duplicate',
  },
  {
    pattern: /Could not update instances/,
    path: 'updateGreenerUnit',
    field: 'externalIdentifier',
    message: 'This identifier cannot be updated, likely a duplicate',
  },
  // Example: Add new patterns here as needed
  // {
  //   pattern: /pattern for error message/,
  //   path: 'mutationName'
  //   field: 'fieldName',
  //   message: "Custom error message for this field.",
  // },
];

//Create an object that tells us which field in a form has an error so we can display in the ui
// checks path and message of a gql error
export function createErrorFieldObject(error: GQLError | null) {
  if (!error) {
    return {};
  }

  let parsedError = {};

  const errors = error?.response?.errors;

  if (errors && errors.length > 0) {
    // Assuming the first entry is the actual error
    const message = errors[0].message;
    const path = errors[0].path;

    // Find the first matching pattern
    const matchingPattern = errorPatterns.find(
      (pattern) => pattern.pattern.test(message) && pattern.path.includes(path)
    );

    if (matchingPattern) {
      parsedError = {
        [matchingPattern.field]: matchingPattern.message,
      };
    }
  }

  return parsedError;
}
